import { Image } from '@chakra-ui/image'
import { Flex, Text } from '@chakra-ui/layout'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { FiltroPedidos } from '../../Devolucoes/FiltroPedidos'
import { TableUsage } from '../../Devolucoes/Table'
import jsPDF from 'jspdf'
import { Button } from '@chakra-ui/react'
import { formatDate } from '../../../utils/formatDate'
import { baseURL } from '../../../services/api'
import { useExcelGenerator } from '../../../hooks/useExcelGenerator'
import { AiOutlineFileExcel, AiOutlineFilePdf } from 'react-icons/ai'
import { EnviarListaParaFornecedor } from './components/EnviarListaParaFornecedor'
import { ModalFiltros } from './components/ModalFiltros'
import { ModalFiltroInicial } from './components/ModalFiltroInicial'
const loading_verde = '../../images/loading-verde.gif'

export function RecebimentoMateriais() {
  const [loading, setLoading] = useState(false)
  const [infos, setInfos] = useState([])
  const [arrayAprova, setArrayAprova] = useState([])
  const [nunota, setNunota] = useState([])
  const [codProd, setCodProd] = useState([])
  const [dataFilter, setDataFilter] = useState([])
  const [sequencia, setSequencia] = useState([])
  const [fornecedores, setFornecedores] = useState([])

  const [fornecedoresSelected, setFornecedoresSelected] = useState([])

  const { generateExcel, loading: excelLoading } = useExcelGenerator()

  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting, isDirty },
    watch,
  } = useForm()

  function handleFornecedoresSelected(fornecedor) {
    if (fornecedoresSelected.includes(fornecedor)) {
      setFornecedoresSelected(fornecedoresSelected.filter((item) => item !== fornecedor))
    } else {
      setFornecedoresSelected([...fornecedoresSelected, fornecedor])
    }
  }

  async function getFornecedores() {
    try {
      const params = {
        pendente: '',
      }
      const response = await baseURL.post('/pedido/recebimento-mercadoria-filtro' + '', params)

      const fornecedores = new Set(response.data.map((item) => item.nome_fornecedor.trim()))
      const arrayFornecedores = Array.from(fornecedores).filter((item) => item !== '')
      setFornecedores(arrayFornecedores)
    } catch (error) {
      console.log(Object.keys(error), error.message)
    }
  }

  useEffect(() => {
    getFornecedores()
  }, [])

  function filtroPorPrazo(prazo) {
    if (!prazo) return

    const newData = dataFilter.filter((item) => item.PRAZO === prazo)
    setInfos(newData)
  }

  const submitForm = async (data) => {
    setLoading(true)

    const params = {
      ...data,
      pendente: fornecedoresSelected.length > 0 ? '' : data.pendente,
      fornecedor: fornecedoresSelected,
    }

    try {
      const response = await baseURL.post('/pedido/recebimento-mercadoria-filtro' + '', params)

      setInfos(response.data)
      setDataFilter(response.data)
      console.log('response', response)

      setLoading(false)
    } catch (error) {
      console.log(Object.keys(error), error.message)
      setLoading(false)
    }
  }

  async function handleGenerateExcel() {
    const header = [
      'Ped Venda',
      'Data Compra',
      'Ped Compra',
      'Forn',
      'Descrição',
      'COD. PROD',
      'COD. FORN',
      'QTD',
      'DATA SAIDA',
      'DATA CHEGOU',
      'PENDENCIA',
      'STATUS RECEBIMENTO',
    ]

    const dataItems = infos.map((item) => [
      item.numero_nota,
      item.data_pedido_compra,
      item.pedido_compra,
      item.nome_fornecedor,
      item.descricao_produto,
      item.cod_prod,
      item.cod_fornecedor,
      item.quantidade_troca,
      formatDate(item.data_saida_mercadoria),
      formatDate(item.data_pedido_chegou),
      item.pendente === 'A' ? 'Atrasado' : item.pendente === 'S' ? 'Pendente' : item.pendente,
      item.status_recebimento === 'R' ? 'Motorista Retira' : item.status_recebimento,
    ])

    generateExcel(header, dataItems, 'RecebimentoMateriais')
  }

  function generatePdf() {
    const doc = new jsPDF({
      orientation: 'landscape',
      unit: 'in',
      format: [(document.documentElement.clientWidth * 0.8) / 72, (document.documentElement.clientHeight * 0.8) / 72],
    })

    doc.setFontSize(8)

    doc.autoTable({
      head: [
        ['Ped Venda', 'Aprov cliente', 'Data Compra', 'Ped Compra', 'Forn', 'Descrição', 'COD. PROD', 'COD. FORN', 'QTD', 'DATA SAIDA', 'PENDENCIA'],
      ],
      body: infos.map((item) => [
        //generate body
        item.numinno,
        `${item.dias_prazo_compra} dias úteis`,
        item.data_pedido_compra ? formatDate(item.data_pedido_compra) : '',
        item.pedido_compra,
        item.nome_fornecedor,
        item.descricao_produto,
        item.cod_prod,
        item.cod_fornecedor,
        item.quantidade_troca,
        formatDate(item.data_saida_mercadoria),
        item.pendente === 'A' ? 'Atrasado' : item.pendente === 'S' ? 'Pendente' : item.pendente,
      ]),
      margin: {
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      styles: { cell: { fontSize: 12 }, halign: 'center' },
      headStyles: {
        halign: 'center',
        valign: 'middle',
      },
    })

    doc.save('RecebimentoMateriais.pdf')
  }

  async function updateStatusAcompanhaCompras() {
    setLoading(true)
    const codUsuario = JSON.parse(localStorage.getItem('authentication')).codigo_usuario

    const parametro = {
      cod_usu: codUsuario,
      numero_nota: arrayAprova,
      nunota: nunota,
      codprod: codProd,
      sequencia: sequencia,
    }

    const response = await baseURL.post('/pedido/atualiza-status-compra-acompanhamento', parametro)
    setLoading(false)
    submitForm({ pendente_etiqueta: 'S' })
  }

  // useEffect(() => {
  //   submitForm({ pendente: '' })
  // }, [])

  const counterNumPed = infos.filter((item, index, self) => self.findIndex((t) => t.numinno === item.numinno) === index).length

  return (
    <>
      <ModalFiltroInicial
        errors={errors}
        register={register}
        handleSubmit={handleSubmit}
        submitForm={submitForm}
        fornecedores={fornecedores}
        isSubmitting={isSubmitting}
      />
      <Flex flexDir="column">
        <Text paddingBlock="2rem" bg="#378BBF" textAlign="center" fontSize="1.2rem" color="white" fontWeight="bold">
          Recebimento de Materiais
        </Text>
        <FiltroPedidos
          isRecebimentoMateriais
          register={register}
          handleSubmit={handleSubmit}
          submitForm={submitForm}
          errors={errors}
          isSubmitting={isSubmitting}
          fornecedores={fornecedores}
          handleFornecedoresSelected={handleFornecedoresSelected}
        />

        <Flex w={'full'} alignItems={'flex-end'} justifyContent={'space-between'}>
          <Text fontSize=".8rem" fontWeight="bold" color="#606163" marginLeft={'1rem'}>
            {counterNumPed} Pedidos - {infos.length} Itens (Quantidade de Itens)
          </Text>
          <Flex gap={2}>
            <ModalFiltros data={dataFilter} loading={loading} filtroPorPrazo={filtroPorPrazo} />
            <EnviarListaParaFornecedor />
            <Button
              mr="1rem"
              mb=".5rem"
              size="sm"
              onClick={generatePdf}
              alignSelf="flex-end"
              justifySelf="flex-end"
              colorScheme="red"
              leftIcon={<AiOutlineFilePdf />}
            >
              Gerar PDF
            </Button>

            <Button
              mr="1rem"
              mb=".5rem"
              size="sm"
              onClick={handleGenerateExcel}
              alignSelf="flex-end"
              justifySelf="flex-end"
              colorScheme="green"
              leftIcon={<AiOutlineFileExcel />}
            >
              Gerar Excel
            </Button>

            <Flex mr="1rem">
              <Button colorScheme="blue" onClick={() => updateStatusAcompanhaCompras()} ml="auto" mb=".5rem" fontSize=".8rem" size="sm">
                Aprovar selecionados
              </Button>
            </Flex>
          </Flex>
        </Flex>

        {loading ? (
          <Flex w="100%" h="calc(100vh - 600px)" bgColor="white">
            <Image m="auto auto" w="auto" h="100px" src={loading_verde} />
          </Flex>
        ) : (
          <>
            <TableUsage
              setLoading={setLoading}
              infos={infos}
              isAcompanhaCompras={true}
              isRecebimentoMateriais
              submitForm={submitForm}
              updateStatusAcompanhaCompras={updateStatusAcompanhaCompras}
              arrayAprova={arrayAprova}
              setArrayAprova={setArrayAprova}
              setNunota={setNunota}
              setCodProd={setCodProd}
              setSequencia={setSequencia}
              sequencia={sequencia}
              codProd={codProd}
              nunota={nunota}
            />
          </>
        )}
      </Flex>
    </>
  )
}
